import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Using the same firebase config from the main application
// This ensures both applications access the same Firebase project
const firebaseConfig = {
  apiKey: "AIzaSyBuJJOHMK6_RXCMB3rVOKLmzyb-AowxB6c",
  authDomain: "saloon-acaed.firebaseapp.com",
  projectId: "saloon-acaed",
  storageBucket: "saloon-acaed.appspot.com",
  messagingSenderId: "664836267275",
  appId: "1:664836267275:web:e7245968aa614c682f560e",
  measurementId: "G-52BNX17L58"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
// Fix for CORS issues when uploading to Firebase Storage from localhost
// Explicitly reference the firebasestorage.app bucket instead of the default appspot.com bucket
const storage = getStorage(app, 'gs://saloon-acaed.firebasestorage.app');

export { auth, db, storage };
